import React from "react";
import "./App.css";
import {createMuiTheme, MuiThemeProvider, withStyles} from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red'
import teal from '@material-ui/core/colors/teal'
import orange from '@material-ui/core/colors/orange'
import PrayerAppbar from "./gui/PrayerAppbar";
import ServerCommunication from "./ServerCommunication";
import Utils from "./Utils";
import LoginPanel from "./gui/loginpanel/LoginPanel";
import HourPanel from "./gui/hourpanel/HourPanel";
import moment from "moment";
import OptionsDrawer from "./gui/OptionsDrawer";
import C from "./Constants";
import "./libs/jquery.query-object";
import PropTypes from "prop-types";
import {Button, Fade, Snackbar, SnackbarContent} from "@material-ui/core";
import {MuiPickersUtilsProvider} from "material-ui-pickers";
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import CircularProgress from "@material-ui/core/CircularProgress";


var theme = createMuiTheme({
    palette: {
        type: 'light',
        primary: teal,
        secondary: orange,
        error: red,
    }
});

const styles = theme => ({
    appBody: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    appBar: {},
    appContent: {
        flexGrow: 1,
        overflow: "hidden",
    },
    snackbar: {
        margin: theme.spacing.unit,
    },
    loadingContainer: {
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
});

class App extends React.Component {

    serverCommunication;

    constructor(props) {
        super(props);
        const that = this;

        this.serverCommunication = new ServerCommunication(this);

        let groupName = Utils.urlParam('g');
        const selectedDateString = Utils.urlParam('d');
        let selectedDate = moment().startOf('day');
        let displayedMonthDatePicker = selectedDate.clone().startOf('month').startOf('day');
        if (selectedDateString != null && selectedDateString.match(C.inputDatePatternRegex)) {
            selectedDate = moment(selectedDateString, C.inputDatePatternMoment);
            displayedMonthDatePicker = selectedDate.clone().startOf('month').startOf('day');
        }
        // noinspection EqualityComparisonWithCoercionJS
        if (groupName == null || groupName == undefined || groupName == "undefined" || groupName == "0") {
            groupName = "";
        }
        const primaryColorString = Utils.urlParam('primaryColor');
        const secondaryColorString = Utils.urlParam('secondaryColor');
        theme = Utils.createTheme(primaryColorString, secondaryColorString);
        let appTitle = Utils.urlParam('appTitle');
        if (appTitle != null && appTitle != ""){
            appTitle = Utils.sanitizeString(appTitle);
        }
        const anonymousGroup = Utils.urlParam('anonymousGroup') == "true";
        const autoLogin = Utils.urlParam('autoLogin') == "true";
        const isDSGVOAccepted = Utils.urlParam('isDSGVOAccepted') == "true";
        if (isDSGVOAccepted){
            Utils.setDSGVOAccepted(true);
        }

        let snackbarMessage = "";
        let snackbarOpen = false;
        let snackbarAction = null;
        let autoHideDuration = 3000;
        if(!Utils.isDSGVOAccepted()){
            snackbarMessage = "Diese Website nutzt Cookies, um bestmögliche Funktionalität bieten zu können";
            snackbarOpen = true;
            snackbarAction = <Button variant="raised" color="secondary" dense
                                     onClick={(event, reason) => {
                                         Utils.setDSGVOAccepted(true);
                                         this.closeSnackbar(event, reason);
                                     }}>OK</Button>;
            autoHideDuration = null; // this is actually bad design, since autohide will than disabled for all other snackbars too.
        }

        this.state = {
            optionsDrawerOpen: false,
            rightDrawerOpen: false,
            groupData: {groupName: groupName},
            weekTitle: "",
            print: {},
            groupNames: [],
            selectedDate: selectedDate,
            dense: false,
            brushMode: null,
            displayedMonthDatePicker: displayedMonthDatePicker,
            anonymousGroup: anonymousGroup,
            snackbarMessage: snackbarMessage,
            snackbarOpen: snackbarOpen,
            snackbarAction: snackbarAction,
            autoHideDuration: autoHideDuration,
            autoLogin: autoLogin,
            appTitle: appTitle,
        };

        Utils.pollLoginStatus(this.serverCommunication, this)();
        if (this.state.groupData.groupName !== ""){
            this.serverCommunication.serverQueryGroupData();
        }

        const loginStatusRequest = () => {
            try {
                that.serverCommunication.serverQueryLoginStatus();
                setTimeout(loginStatusRequest, 20*60*1000);
            } catch (e) {
                console.log(e);
            }
        }
        setTimeout(loginStatusRequest, 20*60*1000);
    }

    componentDidCatch(error, info) {
        this.serverCommunication.serverReportError(error, info.componentStack);
    }

    componentDidMount() {
        const that = this;
        //Utils.readAppParameters(this);
        if (this.state.loginData == null)
            this.serverCommunication.serverQueryLoginStatus();
        if (this.state.groupNames.length <= 0)
            this.serverCommunication.serverQueryAllGroupNames(this.state.anonymousGroup, this.state.groupData != null ? this.state.groupData.groupName : null);
        if (this.state.loginData != null && this.state.loginData.isSuperAdmin && this.state.superAdmins == null)
            this.serverCommunication.serverQueryAllSuperAdmins();
    };

    render() {
        const that = this;
        const {classes} = this.props;
        const hasHourPanelData = this.state.loginData != null && this.state.loginData.isGroupUser && this.state.groupHours != null;
        const showHourPanel = (Utils.getHourPanelViewActive() || this.state.autoLogin);
        return (
            <MuiThemeProvider theme={theme}>
                <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className={classes.appBody}>
                    <PrayerAppbar className={classes.appBar} title={this.state.appTitle != null ? this.state.appTitle : this.state.groupData.groupName}
                                  app={this} hourTypes={this.state.groupData.hourTypes} isPrinting={this.state.print.enabled} groupNames={this.state.groupNames} brushMode={this.state.brushMode} loginData={this.state.loginData}
                                  loggedIn={showHourPanel} groupData={this.state.groupData} selectedDate={this.state.selectedDate} hoursAreDense={this.state.dense}
                                  autoLogin={this.state.autoLogin} anonymousGroup={this.state.anonymousGroup}/>
                    <OptionsDrawer open={this.state.optionsDrawerOpen} app={this} groupData={this.state.groupData}
                                   loginData={this.state.loginData} groupNames={this.state.groupNames} autoLogin={this.state.autoLogin}
                                   superAdmins={this.state.superAdmins}/>
                    {showHourPanel ?
                        (hasHourPanelData ?
                            <HourPanel className={classes.appContent} groupHours={this.resolveGroupHours()} dense={this.state.dense || this.state.print.enabled}
                                   hourTypes={this.resolveHourTypes()} loginData={this.state.loginData} printMode={this.state.print.enabled}
                                   groupData={this.state.groupData} selectedDate={this.state.selectedDate} moveToDate={this.state.moveToDateHourPanel}
                                   app={this} brushMode={this.state.brushMode} ref={h => that.hourPanel = h}/>
                                   : <div className={classes.loadingContainer}><CircularProgress/></div>)
                        : <LoginPanel className={classes.appContent} selectedDate={this.state.selectedDate}
                                    groupData={this.state.groupData} groupNames={this.state.groupNames}
                                    loginData={this.state.loginData} app={this} displayedMonth={this.state.displayedMonthDatePicker}/>}
                    <Snackbar key={this.state.snackbarMessage} open={this.state.snackbarOpen} transition={Fade}
                              onClose={this.closeSnackbar} autoHideDuration={this.state.autoHideDuration}><SnackbarContent
                        message={this.state.snackbarMessage} className={classes.snackbar}
                        action={this.state.snackbarAction}/></Snackbar>
                </div>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        );
    }

    resolveGroupHours() {
        if(!this.state.print.enabled) return this.state.groupHours;
        const filteredGroupHours = {};
        for (const hour in this.state.groupHours) {
            const date = moment(hour, C.inputDatePatternMoment);
            if(!date.isBefore(this.state.print.from) && !date.isAfter(this.state.print.to))
                filteredGroupHours[hour] = this.state.groupHours[hour];
        }
        return filteredGroupHours;
    }
    resolveHourTypes() {
        if(!this.state.print.enabled){
            if(this.state.groupData != null && this.state.groupData.hourTypes != null){
                return this.state.groupData.hourTypes;
            } else {
                this.serverCommunication.serverQueryGroupData();
                return [];
            }
        }
        return this.state.print.hourTypes != null ? this.state.print.hourTypes : [];
    }
    changeGroupName = (groupName) => {
        //this.serverCommunication.
        let groupNameVariable = "";
        if (groupName != null && groupName != "") {
            groupNameVariable += groupName;
        }
        if (this.state.groupData.groupName != groupNameVariable) {
            window.history.pushState(Utils.guid(), Utils.guid(), Utils.updateUrlParameter("g", groupNameVariable));
            this.setState({groupData: {groupName: groupNameVariable}, groupHours: null}, () => {
                this.serverCommunication.serverQueryGroupData();
                this.serverCommunication.serverQueryLoginStatus();
            });
        }
    };
    forceUpdateGroupHours = () => this.hourPanel != null ? this.hourPanel.forceUpdate() : null;
    changeDisplayMonth = (month) => this.setState({displayedMonthDatePicker: month});
    changeSelectedDate = (selectedDate) => {
        //this.serverCommunication.
        if (!selectedDate.isSame(this.state.selectedDate)) {
            window.history.pushState(Utils.guid(), Utils.guid(), Utils.updateUrlParameter("d", "" + selectedDate.format(C.inputDatePatternMoment)));
        }
        this.setState({selectedDate: selectedDate.clone(), moveToDatePicker: selectedDate.clone().startOf('month').startOf('day')}, () => {
            //this.serverCommunication.serverQueryGroupData()
        });
    };
    deactivatePopover = () => this.setState({versionPopup: true});
    isLoggedIn = () => {
        return this.state.loginData !== undefined && this.state.loginData !== null &&
            this.state.loginData.isGroupUser === true && Utils.getHourPanelViewActive();
    };
    isAutoLogin = () => this.state.autoLogin;
    getNullableGroupName = () => this.state != null && this.state.groupData != null ? this.state.groupData.groupName : "";
    toggleOptionsDrawer = () => this.setState({optionsDrawerOpen: !this.state.optionsDrawerOpen, rightDrawerOpen: false});
    closeSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        this.setState({snackbarOpen: !this.state.snackbarOpen});
    };
    setBrushMode = (mode) => this.setState({brushMode: mode});
    toggleDensity = () => this.setState({dense: !this.state.dense});
    responseMessage = (message, reason, actionText) => {
        if (message != null && message !== "") {
            let actionButton = null;
           // if (reason != null) actionButton = <Button color="secondary" onClick={action} dense>{actionText}</Button>;
            this.setState({snackbarOpen: true, snackbarMessage: message, snackbarAction: actionButton});
        }
        if (reason != null && reason !== ""){

        }
        //TODO response
    };
}


App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
